import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import Page from '../components/Page';
import { DecryptData } from '../utils/encryptDecrypt';
import { useDispatch } from 'react-redux';
import { breadcrumbActions } from '../redux/reducers/breadcrumb';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex'
    }
}));
// ----------------------------------------------------------------------

export default function Logout() {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const ClearLocalStorage = () => {
        let loginPath = DecryptData(localStorage.getItem('loginSource'))
        dispatch(breadcrumbActions.removeAll(null))
        localStorage.clear();
        
        if (loginPath) {
            navigate(`/${loginPath}`)
        }
        else {
            navigate('/login')
        }
    }
    useEffect(() => ClearLocalStorage(), []);

    return (
        <RootStyle title="Admin Login">
            Logging Out....
        </RootStyle>
    );
}
